export enum ActionKeyEnum {
	GenerateQRCode,
	CopyCVSharingLink,
}
